var styles = {"article":"HeaderBack-module_article__hB8-a","padding-wide":"HeaderBack-module_padding-wide__L4VLx"};

export { styles as default };
